import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { RegistrationService } from 'src/app/shared/services/registration.service';
import { environment } from 'src/environments/environment';
import { FileService } from 'src/app/shared/services/file.service';
import { Common } from 'src/app/common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ImagePreviewComponent } from 'src/app/modules/modals/image-preview/image-preview.component';
declare var  $ :any

@Component({
  selector: 'app-user-leave-atndce',
  templateUrl: './user-leave-atndce.component.html',
  styleUrls: ['./user-leave-atndce.component.css']
})
export class UserLeaveAtndceComponent implements OnInit {

  leaveApplyForm: FormGroup;
  compOffApplyForm: FormGroup;
  leaveLst: any = []; dtReneder: boolean = false; dtOptions = {};
  uploaded: boolean = false; max_date = Date;
  selectedLeaveTypeFilter: any = '1';
  hldyLst: any = [];
  leaveBalanceLSt: any;
  userId: any = '';
  leaveTypes: any[] = [];
  fromDayType: any = '';
  toDayType: any = '';
  minDate: Date = new Date();
  maxDate: Date = new Date();
  compOffappliedDate: any = new Date();
  compOffDate: any = new Date();
  startTime: any = new Date();
  endTime: any = new Date();
  savedLeave: any = [];
  compoffData: any = [];
  attachments: any = [];
  uploadFileNames: any = [];
  enableToDate: boolean = true;
  enableFromDate: boolean = true;
  dayType: boolean = true;
  enableFromHalfdayType: boolean = true;
  enableToDayType: boolean = true;
  enableFromDayType: boolean = true;
  enableHalfFullType: boolean = false;
  enableendTime: boolean = false;
  enableStartTime: boolean = false;
  documentId: any = '';
  fromMinDate: any;
  fromMaxDate: any;
  toMinDate: any;
  toMaxDate: any;
  selectedLeaveType: number;
  openModal:boolean=false;
  uploadFile:any
  compOffDateonly: Date;

  constructor(
    private registrationService: RegistrationService,
    private toaster: ToastrService,
    private datepipe: DatePipe,
    private fileService: FileService,
    private fb: FormBuilder,
    private regService: RegistrationService,
    private datePipe: DatePipe,
    public changeDetection: ChangeDetectorRef,
    private modalService: NgbModal,
  ) { }


  ngOnInit(): void {
    this.userId = JSON.parse(sessionStorage.getItem('loginId') || '{}');
    this.inItFormControl();
    this.loadData(); 
    // this.loadApis('');
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 15,
      dom: 'Bfrtip',
      processing: true,
      buttons: [
        {
          extend: 'excelHtml5',
          title: 'Holiday list',
          exportOptions: { columns: ':visible:not(:first-child)' }
        },
      ]
    };
    const now = new Date();
    const hours = now.getHours().toString().padStart(2, '0');
    const minutes = now.getMinutes().toString().padStart(2, '0');
    this.startTime = `${hours}:${minutes}`;
    this.endTime = `${hours}:${minutes}`;
  }
  inItFormControl() {
    this.leaveApplyForm = this.fb.group({
      selectedLeaveType: ['', Validators.required],
      appliedDate: [new Date(), Validators.required],
      fromDate: [new Date(), Validators.required],
      toDate: [new Date(), Validators.required],
      reasons: ['', Validators.required],
      fromDayType: ['', Validators.required],
      toDayType: ['', Validators.required],
      applyendTime: ['', Validators.required],
      applystartTime: ['', Validators.required],
      halfFullDayType: ['', Validators.required]
    });
    this.compOffApplyForm = this.fb.group({
      compOffappliedDate: [new Date(), Validators.required],
      compOffDate: [new Date(), Validators.required],
      startTime: ['', Validators.required],
      endTime: ['', Validators.required]
    });
  }
  loadApis(type: any) {
    this.attachments = [];
    this.uploadFile = null
      this.uploadFileNames = [];
      this.updateDateLimits('leaveType', new Date())
    this.inItFormControl();
    if (type == 'holiday') {
      this.loadHolidays();
    }
    else if (type == 'leavebal') {
      this.loadLeaveBalance();
    }
    else if (type == 'applyLeave') {
      this.loadLeaveTypes();
    }
    else if (type == 'compoff') {
      // this.loadCompOff();
    }

  }
  filterLeaveType(event: any) {
    this.selectedLeaveTypeFilter = event.target.value;
    this.loadData(this.selectedLeaveTypeFilter)
  }
  loadData(selectedLeaveTypeFilter: any = '1') {
    this.leaveLst = [];
    this.dtReneder = false;
    this.registrationService.get(selectedLeaveTypeFilter == '1' ? `mvu/empappliedleaves/getallbyuserid/${this.userId}` : `mvu/compoff/getallbyuserid/${this.userId}`).subscribe(
      (res) => {
        if (res.status == 'OK') {
          if (res.data == '' || res.data == null || res.data == undefined) {
            this.dtReneder = true;
            this.toaster.info(res.message)
          }
          else {
            this.leaveLst = res.data;
            this.dtReneder = true;
            this.toaster.success(res.message)
          }
        }
        else {
          this.toaster.error(res.message)
        }
      }
    )
  }
  loadHolidays() {
    this.dtReneder = false;
    this.registrationService.get(`masters/getallmasterleaves`).subscribe(
      (res) => {
        if (res.status == 'OK') {
          if (res.data == '' || res.data == null || res.data == undefined) {
            this.toaster.info(res.message)
          }
          else {
            this.hldyLst = res.data;
            this.dtReneder = true;
            this.toaster.success(res.message)
          }
        }
        else {
          this.toaster.error(res.message)
        }
      }
    )
  }
  loadLeaveBalance() {
    this.dtReneder = false;
    this.registrationService.get(`mvu/leavemanagement/findbyuserid/${this.userId}`).subscribe(
      (res) => {
        if (res.status == 'OK') {
          if (res.data == '' || res.data == null || res.data == undefined) {
            this.toaster.info(res.message)
          }
          else {
            this.leaveBalanceLSt = res.data;
            this.dtReneder = true;
            this.toaster.success(res.message)
          }
        }
        else {
          this.toaster.error(res.message)
        }
      }
    )
  }
  loadLeaveTypes() {
    this.dtReneder = false;
    this.registrationService.get(`masters/getallleavetypes`).subscribe(
      (res) => {
        if (res.status == 'OK') {
          if (res.data == '' || res.data == null || res.data == undefined) {
            this.toaster.info(res.message)
          }
          else {
            this.leaveTypes = res.data;
            this.dtReneder = true;
            // this.toaster.success(res.message)
          }
        }
        else {
          this.toaster.error(res.message)
        }
      }
    )
  }
  validateLeaveType(type: any) {
    this.leaveApplyForm.get('toDate')?.setValue(new Date());
    this.leaveApplyForm.get('fromDate')?.setValue(new Date());

    // Reset all enables to default state
    this.enableFromDate = true;
    this.enableToDate = true;
    this.enableStartTime = false;
    this.enableendTime = false;
    this.enableFromDayType = true;
    this.enableToDayType = true;
    this.enableHalfFullType = false;
    this.enableFromHalfdayType = true; // default visible

    // Reset all validators to clear previous state
    this.leaveApplyForm.get('fromDayType').clearValidators();
    this.leaveApplyForm.get('toDayType').clearValidators();
    this.leaveApplyForm.get('applystartTime').clearValidators();
    this.leaveApplyForm.get('applyendTime').clearValidators();
    this.leaveApplyForm.get('fromDate').clearValidators();
    this.leaveApplyForm.get('toDate').clearValidators();
    this.leaveApplyForm.get('halfFullDayType').clearValidators();

    // Reset dependent field values
    this.leaveApplyForm.patchValue({
      fromDayType: '',
      toDayType: '',
      applystartTime: '',
      applyendTime: '',
    });

    switch (type) {
      // 🟢 Case 3: Casual / Compensatory Off (Single day full leave)
      case '3':
        this.enableToDate = false;
        this.enableFromHalfdayType = false;
        this.enableToDayType = false;
        this.leaveApplyForm.get('fromDayType').setValue('2'); // Full Day
        this.leaveApplyForm.get('fromDate').setValidators([Validators.required]);
        break;

      // 🟢 Case 4: Short Leave / Hourly leave
      case '4':
        this.enableToDate = false;
        this.enableFromDate = false;
        this.enableStartTime = true;
        this.enableendTime = true;
        this.enableFromDayType = false;
        this.enableToDayType = false;
        this.leaveApplyForm.get('applystartTime').setValidators([Validators.required]);
        this.leaveApplyForm.get('applyendTime').setValidators([Validators.required]);
        break;

      // 🟢 Case 5: Half-Day Leave
      case '5':
        this.enableToDate = false;
        this.enableFromDayType = false;
        this.enableToDayType = false;
        this.enableHalfFullType = true;
        this.leaveApplyForm.get('fromDate').setValidators([Validators.required]);
        this.leaveApplyForm.get('halfFullDayType').setValidators([Validators.required]);
        break;

      // 🟢 Default Case: Normal full-day leave
      default:
        this.enableFromDate = true;
        this.enableToDate = true;
        this.enableFromDayType = true;
        this.enableToDayType = true;
        this.leaveApplyForm.get('fromDate').setValidators([Validators.required]);
        this.leaveApplyForm.get('toDate').setValidators([Validators.required]);
        this.leaveApplyForm.get('fromDayType').setValidators([Validators.required]);
        this.leaveApplyForm.get('toDayType').setValidators([Validators.required]);
        break;
    }

    // 🔄 Recalculate validity after setting validators
    this.leaveApplyForm.get('fromDayType').updateValueAndValidity();
    this.leaveApplyForm.get('toDayType').updateValueAndValidity();
    this.leaveApplyForm.get('applystartTime').updateValueAndValidity();
    this.leaveApplyForm.get('applyendTime').updateValueAndValidity();
    this.leaveApplyForm.get('fromDate').updateValueAndValidity();
    this.leaveApplyForm.get('toDate').updateValueAndValidity();
    this.leaveApplyForm.get('halfFullDayType').updateValueAndValidity();
   if(type){
   
    this.updateDateLimits('leaveType',type );
   }
   
  }
  onStartTimeChange(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    const selectedTime = inputElement.value; // e.g., "09:30"

    this.leaveApplyForm.get('applystartTime')?.setValue(selectedTime);

    if (selectedTime) {
      const [hours, minutes] = selectedTime.split(':').map(Number);
      let newHours = hours + 1;
      if (newHours >= 24) newHours = newHours - 24;

      const newTime = `${newHours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;

      // ✅ Patch value to end time
      this.leaveApplyForm.patchValue({
        applyendTime: newTime
      });


    }
  }




  saveAppliedLeave() {
    this.dtReneder = false;
    this.savedLeave = [];
    const noOfDays = this.calculateDifferenceInDays({
      fromDate: this.leaveApplyForm.get('fromDate').value,
      toDate: this.leaveApplyForm.get('toDate').value,
      from_date_type: this.leaveApplyForm.get('fromDayType').value,
      to_date_type: this.leaveApplyForm.get('toDayType').value,
      halfFullDayType: this.leaveApplyForm.get('halfFullDayType').value || '',
    });
    const maxDays = 3;
    const compoffminDays = 1;
    const selectedLeaveType = this.leaveTypes.find(type => type.id === +this.leaveApplyForm.get('selectedLeaveType').value);
    if (this.leaveApplyForm.invalid) {
      this.toaster.warning('Please fill all mandatory fields');
      this.leaveApplyForm.markAllAsTouched();
      return;
    }
    else if (noOfDays > maxDays && selectedLeaveType?.name?.toLowerCase().trim() !== 'compensatory off') {
      this.toaster.warning(`Leave duration cannot exceed ${maxDays} days`);
    }
    else if (noOfDays > compoffminDays && selectedLeaveType?.name?.toLowerCase().trim() === 'compensatory off') {
      this.toaster.warning(`Compensatory off duration cannot be greater than ${compoffminDays} days`);
    }
    else {
      if(this.attachments && this.attachments.length > 0){
        this.saveFile();
      }
     
      setTimeout(() => {
        const mvuId = sessionStorage.getItem('MVUID');
        const userId = sessionStorage.getItem('loginId');
        const name = JSON.parse(sessionStorage.getItem('firstname'));
        let payload: any = {
          applied_date: this.leaveApplyForm.get('appliedDate').value,
          from_date: this.leaveApplyForm.get('fromDate').value,
          leave_type_id: this.leaveApplyForm.get('selectedLeaveType').value,
          mvu_id: mvuId,
          name: name,
          no_of_days: noOfDays,
          reasons: this.leaveApplyForm.get('reasons').value,
          status_id: 1,
          to_date: this.leaveApplyForm.get('selectedLeaveType').value == '3' || this.leaveApplyForm.get('selectedLeaveType').value == '5' ? this.leaveApplyForm.get('fromDate').value : this.leaveApplyForm.get('toDate').value,
          upload: this.uploadFileNames.length > 0 ? this.uploadFileNames[0] : null,
          user_id: userId,
          user_document_id: this.documentId || ''
        }
        if (this.leaveApplyForm.get('selectedLeaveType').value === '4') {
          const startTime = this.leaveApplyForm.get('applystartTime')?.value;
          const endTime = this.leaveApplyForm.get('applyendTime')?.value;

          let startDateTime = null;
          let endDateTime = null;

          if (startTime) {
            const today = new Date().toISOString().split('T')[0]; // "2025-11-03"
            startDateTime = `${today}T${startTime}:00`;
          }

          if (endTime) {
            const today = new Date().toISOString().split('T')[0];
            endDateTime = `${today}T${endTime}:00`;
          }
          payload = {
            ...payload,
            to_date: this.datePipe.transform(new Date(), 'yyyy-MM-dd'),
            from_date: this.datePipe.transform(new Date(), 'yyyy-MM-dd'),
            end_time: endDateTime,
            start_time: startDateTime,
          };
        }
        this.registrationService.post(`mvu/empappliedleaves/save`, payload).subscribe(
          (res) => {
            if (res.status == 'OK') {
              if (res.data == '' || res.data == null || res.data == undefined) {
                this.toaster.info(res.message)
              }
              else {
                this.savedLeave = []
                this.savedLeave = res.data;
                this.toaster.success(res.message);
                 $('#applyleave').modal('hide');
                this.inItFormControl();
               
                this.loadData();
              }
            }
            else {
              this.toaster.error(res.message)
            }
          }
        )

      },2000);

    }
  }
  onFileChange(event: any) {
    if (event.target.files && event.target.files.length > 0) {
      this.attachments = Array.from(event.target.files);
      this.uploadFileNames = this.attachments.map(file => file.name); // just the filenames
    } 
    else {
      this.attachments = [];
      this.uploadFileNames = [];
    }
  }
  saveFile() {
    // if (!this.attachments || this.attachments.length === 0) {
    //   this.toaster.error("Please select a file first!");
    //   return;
    // }
    const tenantId = sessionStorage.getItem('TENANT_ID');
    let screenName;
    const userData = JSON.parse(sessionStorage.getItem('logUsrRoleId'));
    const userDetails = JSON.parse(sessionStorage.getItem('DoctorDetails'));
    const userID = userDetails ? userDetails.id : null;
    if ([58, 74].includes(userData?.role_id)) screenName = 'HEALTHWORKER';
    else if (userData === 54) screenName = 'DRIVER';
    else if (userData === 7) screenName = 'DOCTOR';
    else if (userData === 4) screenName = 'PHARMACY';
    else if (userData === 5) screenName = 'LAB';
    else if (userData === 13) screenName = 'AGENT';
    const formData = new FormData();
    this.attachments.forEach(file => {
      formData.append('file', file);
    });
    formData.append('fileTypeId', '113');
    formData.append('isActive', 'true');
    formData.append('screenName', screenName);
    formData.append('reg_id', userID);

    this.regService
      .postWithoutTnt(`file-service/jwt/file/upload?TENANT_ID=${tenantId}`, formData)
      .subscribe({
        next: (res) => {
          this.toaster.success('Upload SuccessFully');
          if (res.status == 'success') {
            this.documentId = res.response.id;
            this.loadData(1);
          }
        },
        error: (err: HttpErrorResponse) => {
          this.toaster.error(err.message);
        }
      });
  }

  saveCompOff() {
    this.dtReneder = false;
    this.compoffData = [];
    const mvuId = sessionStorage.getItem('MVUID');
    const userId = sessionStorage.getItem('loginId');
    const noOfDays = this.calculateCompOffDays(this.compOffApplyForm.get('compOffappliedDate').value, this.compOffApplyForm.get('compOffDate').value, this.compOffApplyForm.get('startTime').value, this.compOffApplyForm.get('endTime').value);

    if (this.compOffApplyForm.invalid) {
      this.toaster.warning('Please fill all mandatory fields');
      this.compOffApplyForm.markAllAsTouched();
      return;
    }
    else {

      let payload = {
        applied_date: this.datePipe.transform(this.compOffApplyForm.value.compOffappliedDate,'yyyy-MM-ddTHH:mm:ss'),
        comp_off_date:  this.datePipe.transform(new Date(this.compOffApplyForm.value.compOffDate),'yyyy-MM-ddTHH:mm:ss'),
        from_time: this.compOffApplyForm.get('startTime').value,
        mvu_id: mvuId,
        no_of_days: noOfDays,
        status: 1,
        to_time: this.compOffApplyForm.get('endTime').value,
        user_id: userId
      }

      this.registrationService.post(`mvu/compoff/save`, payload).subscribe(
        (res) => {
          if (res.status == 'OK') {
            if (res.data == '' || res.data == null || res.data == undefined) {
              this.toaster.info(res.message)
            }
            else {
              this.compoffData = res.data;
              this.dtReneder = true;
              this.toaster.success(res.message);
              ($('#applycompff') as any).modal('hide');
              this.loadData()
            }
          }
          else {
            this.toaster.error(res.message)
          }
        }
      )
    }
  }
  calculateDifferenceInDays(values: { fromDate?: Date; toDate?: Date; from_date_type?: string; to_date_type?: string; halfFullDayType?: string }): number {
    let differenceInDays = 0;
    if (this.leaveApplyForm.get('selectedLeaveType').value === '5' && values.fromDate) {
      differenceInDays = 0.5;
    } else if (this.leaveApplyForm.get('selectedLeaveType').value === '4') {
      differenceInDays = 0;
    }
    else if (this.leaveApplyForm.get('selectedLeaveType').value === '3') {
      differenceInDays = 1;
    }
    else if (values.halfFullDayType === '1' || values.halfFullDayType === '2') {
      differenceInDays = 0.5;
    }
    else if (values.fromDate && values.toDate) {
      const fromDateMillis = new Date(values.fromDate).getTime();
      const toDateMillis = new Date(values.toDate).getTime();
      const differenceInTime = toDateMillis - fromDateMillis;
      let daysBetween = differenceInTime / (1000 * 3600 * 24) + 1;
      if (values.from_date_type === '1') {
        daysBetween -= 0.5;
      }
      if (values.to_date_type === '1') {
        daysBetween -= 0.5;
      }
      if (values.fromDate && values.toDate && fromDateMillis === toDateMillis) {
        if (values.from_date_type === '2' && values.to_date_type === '2') {
          daysBetween = 1;
        }
      }
      if (values.fromDate && values.toDate && fromDateMillis === toDateMillis) {
        if (values.from_date_type === '1' && values.to_date_type === '1') {
          daysBetween = 0.5;
        }
      }
      differenceInDays = daysBetween;
    }
    return differenceInDays;
  }
  // Helper method to calculate number of days for CompOff
  calculateCompOffDays(compOffappliedDate: string | Date, compOffDate: string | Date, startTime: string | Date, endTime: string | Date): number {
    if (!startTime || !endTime) return 0;

    let start: Date;
    let end: Date;

    // If the value is string (like "10:30"), convert to Date using today as reference
    if (typeof startTime === 'string') {
      const [startH, startM] = startTime.split(':').map(Number);
      start = new Date();
      start.setHours(startH, startM, 0, 0);
    } else {
      start = new Date(startTime);
    }

    if (typeof endTime === 'string') {
      const [endH, endM] = endTime.split(':').map(Number);
      end = new Date();
      end.setHours(endH, endM, 0, 0);
    } else {
      end = new Date(endTime);
    }

    // Calculate difference in hours
    const differenceInHours = (end.getTime() - start.getTime()) / (1000 * 3600);

    // Convert to fractional days (assuming 8 hours = 1 day)
    const noOfDays = differenceInHours / 8;

    // Prevent negative or NaN
    return isNaN(noOfDays) || noOfDays < 0 ? 0 : Number(noOfDays.toFixed(3));
  }

updateDateLimits(actionType: 'leaveType' | 'fromDate' |'toDate', value: any) {
  this.changeDetection.detectChanges();
  const today = new Date();

  if (actionType === 'leaveType') {
    // Reset all first
    this.fromMinDate = undefined;
    this.fromMaxDate = undefined;
    this.toMinDate = undefined;
    this.toMaxDate = undefined;

    // For Health Reason / Emergency
    if (Number(value) === 1 || Number(value) === 2) {
       this.changeDetection.detectChanges();
      this.fromMinDate = today;   // From date min = today
      this.fromMaxDate = undefined; // No max limit
      this.toMinDate = this.fromMinDate; // Will be set after selecting From Date
      this.toMaxDate = this.addDays(today, 3);
    }
    if (Number(value) === 3) {
      this.fromMinDate =  today;  // From date min = today
      this.fromMaxDate = this.addDays(today, 44);// No max limit
    }
    if (Number(value) === 5) {
      this.fromMinDate = today;  // From date min = today
    }
  }

  if (actionType === 'fromDate' && value) {
    if (Number(this.leaveApplyForm.get('selectedLeaveType')?.value) === 1 || (Number(this.leaveApplyForm.get('selectedLeaveType')?.value) === 2)) {
     this.changeDetection.detectChanges();
      this.leaveApplyForm.get('toDate')?.setValue(this.leaveApplyForm.get('fromDate')?.value);
      this.toMinDate = this.leaveApplyForm.get('fromDate')?.value;
      this.toMaxDate = this.addDays( this.toMinDate, 2);
    }
    else{
    this.leaveApplyForm.get('toDate')?.setValue(this.leaveApplyForm.get('fromDate')?.value);
  }
  }
  this.dateChangesFieldDisabled();
}
formatDate(d: any): string {
  if (!d) return '';
  const date = new Date(d);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
}


dateChangesFieldDisabled(){
   this.changeDetection.detectChanges();
  const from = this.formatDate(this.leaveApplyForm.value.fromDate);
const to = this.formatDate(this.leaveApplyForm.value.toDate);
const leaveType = Number(this.leaveApplyForm.get('selectedLeaveType')?.value);

if (from === to && (leaveType === 1 || leaveType === 2)) {

  this.leaveApplyForm.get('fromDayType')?.setValue('2');
  this.leaveApplyForm.get('fromDayType')?.disable();

  this.leaveApplyForm.get('toDayType')?.setValue('2');
  this.leaveApplyForm.get('toDayType')?.disable();

} else {

  this.leaveApplyForm.get('fromDayType')?.reset();
  this.leaveApplyForm.get('toDayType')?.reset();

  this.leaveApplyForm.get('fromDayType')?.enable();
  this.leaveApplyForm.get('toDayType')?.enable();
}

}

addDays(date: Date, days: number): Date {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}

toasterMessages(value: any) {
const selectedLeaveType = this.leaveTypes.find(type => Number(type.id) === Number(value));

  if(Number(value) === 1 || Number(value) === 2) {
    this.toaster.info(`${selectedLeaveType?.name} is applicable for only three days of leave.`);
  } else if(Number(value) === 3) {
    this.toaster.info(`${selectedLeaveType?.name} duration cannot be greater than 1 days`);
  }
   else if(Number(value) === 4) {
    this.toaster.info(`${selectedLeaveType?.name} is applicable for 1 hour only.`);
  }
   else if(Number(value) === 5) {
    this.toaster.info(`This Leave type is applicable for only ${selectedLeaveType?.name}.`);
  }
}

comOffOnly(event){
  this.changeDetection.detectChanges();
  const today = new Date();
       this.compOffDateonly = this.addDays(today, -44);  // From date min = today
    
}

viewImage(imageUrl: string) {
  let webURL = location.href.includes('localhost')
    ? environment.applicationURL
    : location.origin;

  const finalUrl = `${webURL}/${imageUrl}`;

  window.open(finalUrl, "_blank");  


}
}

